// src/components/PianoLoadingScreen.jsx
// Premium animated loading screen — replaces plain "Checking access…" text
// Used in ProtectedLevelRoute + PwpPaywall

import React from "react";

export default function PianoLoadingScreen({ message = "Loading…" }) {
  return (
    <div style={ROOT}>
      <style>{CSS}</style>

      {/* Logo */}
      <img
        src="/icons/pwp-192.png"
        alt="Piano With Pan"
        style={LOGO}
        onError={e => { e.currentTarget.style.display = "none"; }}
      />

      {/* Animated piano keys */}
      <div style={KEYS_WRAP}>
        {[0,1,2,3,4,5,6].map(i => (
          <div
            key={i}
            className="pls-white-key"
            style={{ animationDelay: `${i * 0.11}s` }}
          />
        ))}
        {/* Black keys overlay */}
        <div style={BLACK_ROW}>
          {[0,1,2,3,4].map(i => (
            <div
              key={i}
              className="pls-black-key"
              style={{
                animationDelay: `${i * 0.13 + 0.05}s`,
                marginLeft: i === 2 ? "1.6rem" : 0,
              }}
            />
          ))}
        </div>
      </div>

      {/* Brand */}
      <div style={BRAND}>Piano With Pan™</div>

      {/* Message + dots */}
      <div style={MSG_ROW}>
        <span style={MSG_TEXT}>{message}</span>
        <span className="pls-dots">
          <span>.</span><span>.</span><span>.</span>
        </span>
      </div>
    </div>
  );
}

/* ── Styles ─────────────────────────────────────────────── */
const ROOT = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 20,
  background: "linear-gradient(160deg, #7DD8F8 0%, #EEF6FF 55%, #FFE4B0 100%)",
  fontFamily: "'Fredoka One', 'Nunito', sans-serif",
};

const LOGO = {
  width: 72,
  height: 72,
  borderRadius: 18,
  objectFit: "contain",
  boxShadow: "0 8px 28px rgba(0,0,0,0.14)",
};

const KEYS_WRAP = {
  position: "relative",
  display: "flex",
  gap: 4,
  padding: "0 2px",
};

const BLACK_ROW = {
  position: "absolute",
  top: 0,
  left: 18,
  display: "flex",
  gap: 12,
};

const BRAND = {
  fontSize: "1.25rem",
  color: "#1e3a5f",
  letterSpacing: "0.04em",
  marginTop: 4,
};

const MSG_ROW = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  fontSize: "0.9rem",
  fontWeight: 700,
  color: "#64748b",
  fontFamily: "'Nunito', sans-serif",
};

const MSG_TEXT = {
  fontFamily: "'Nunito', sans-serif",
  fontWeight: 800,
  fontSize: "0.88rem",
  color: "#475569",
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Fredoka+One&family=Nunito:wght@700;800&display=swap');

  @keyframes pls-bounce {
    0%, 100% { transform: translateY(0);    background: #fff; }
    40%       { transform: translateY(-14px); background: #a5f3fc; }
    60%       { transform: translateY(-8px);  background: #7dd3fc; }
  }

  @keyframes pls-bounce-b {
    0%, 100% { transform: translateY(0);    background: #1e293b; }
    40%       { transform: translateY(-10px); background: #4f46e5; }
    60%       { transform: translateY(-5px);  background: #6366f1; }
  }

  @keyframes pls-dot {
    0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
    40%           { opacity: 1;   transform: scale(1.2); }
  }

  .pls-white-key {
    width: 32px;
    height: 80px;
    border-radius: 0 0 8px 8px;
    background: #ffffff;
    border: 1.5px solid #cbd5e1;
    box-shadow: 0 4px 12px rgba(0,0,0,0.10);
    animation: pls-bounce 0.9s ease-in-out infinite;
    flex-shrink: 0;
  }

  .pls-black-key {
    width: 20px;
    height: 50px;
    border-radius: 0 0 5px 5px;
    background: #1e293b;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
    animation: pls-bounce-b 0.9s ease-in-out infinite;
    flex-shrink: 0;
  }

  .pls-dots span {
    display: inline-block;
    font-size: 1.4rem;
    font-weight: 900;
    color: #94a3b8;
    animation: pls-dot 1.2s ease-in-out infinite;
    line-height: 1;
  }
  .pls-dots span:nth-child(1) { animation-delay: 0s; }
  .pls-dots span:nth-child(2) { animation-delay: 0.2s; }
  .pls-dots span:nth-child(3) { animation-delay: 0.4s; }
`;